module.exports = __webpack_public_path__ + "img/yml_main2.86bb169a.jpg";